module.exports = "/layout/app/images/bg-veelloman.e8477029.svg";